import React, { useContext, useEffect, useState } from "react";

import estilo from "./styles/Menu.module.css";

import { Link } from "react-router-dom";
import SubirVideo from "./SubirVideo";
import { DataContext } from "../context/DataContext";
import supabase from "../supabase/supabaseClient";

function Menu() {
  const {
    activarSubir,
    setActivarSubir,
    activarBuscar,
    activarBuscador,
    activarLupa,
    activarLupaResponsive,
  } = useContext(DataContext);

  function subir() {
    setActivarSubir(!activarSubir);
  }

  const [input, setInput] = useState("");
  const [resultado, setResultado] = useState([]);

  var inputFinal;

  function capturarInput(e) {
    setInput(e.target.value);
  }

  input === "" || input === " "
    ? (inputFinal = null)
    : (inputFinal = input
        .normalize("NFD")
        .replace(/[\u0300-\u0302\u0308\u030a\u0327]/g, "")
        .replace(/[.,]/g, " ")
        .normalize("NFC"));

  useEffect(() => {
    const fetchBuscar = async () => {
      const { data, error } = await supabase
        .from("usuarios")
        .select()
        .or(`nombre.ilike.%${inputFinal}%,usuario.ilike.%${inputFinal}%`);

      // .ilike("nombre", `%${inputFinal}%`);

      if (data) {
        // console.log(data);
        setResultado(data);
      }
    };

    fetchBuscar();
  }, [inputFinal]);

  return (
    <div className={estilo.menu}>
      <div className={estilo.espacio}></div>

      <div className={estilo.menu_pagina}>
        {/* lupa responsiva */}
        {activarLupa ? (
          <div className={estilo.lupa_responsive}>
            <input
              placeholder="Buscar"
              onClick={() => activarBuscador(true)}
              onChange={capturarInput}
              value={input}
            />

            <div
              className={estilo.icono_lupa}
              onClick={() => activarLupaResponsive(false, false)}
            >
              <svg width="48" height="48" viewBox="0 0 24 24">
                <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z"></path>
              </svg>
            </div>
          </div>
        ) : null}

        {/* resultados responsivos */}
        {resultado.length > 0 ? (
          <div
            className={
              activarBuscar
                ? estilo.buscador_resultados_responsive
                : estilo.no_buscador
            }
          >
            {resultado.map((e, i) => (
              <Link
                key={i}
                to={"/" + e.nombre}
                onClick={() => activarBuscador(false)}
              >
                <div className={estilo.buscador_dato}>
                  <svg width="22" height="22" viewBox="0 0 24 24">
                    <path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"></path>
                  </svg>
                  <p>{e.nombre}</p>
                </div>
              </Link>
            ))}
          </div>
        ) : null}

        {/* contenido */}
        <div className={estilo.logo}>
          <svg width="34" height="34" viewBox="0 0 24 24">
            <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
          </svg>

          <Link to={"/"}>
            <div className={estilo.nombre}>
              <svg width="34" height="34" viewBox="0 0 24 24">
                <path d="M21.593 7.203a2.506 2.506 0 0 0-1.762-1.766C18.265 5.007 12 5 12 5s-6.264-.007-7.831.404a2.56 2.56 0 0 0-1.766 1.778c-.413 1.566-.417 4.814-.417 4.814s-.004 3.264.406 4.814c.23.857.905 1.534 1.763 1.765 1.582.43 7.83.437 7.83.437s6.265.007 7.831-.403a2.515 2.515 0 0 0 1.767-1.763c.414-1.565.417-4.812.417-4.812s.02-3.265-.407-4.831zM9.996 15.005l.005-6 5.207 3.005-5.212 2.995z"></path>
              </svg>

              <h1>ClonTube</h1>
            </div>
          </Link>
        </div>

        <div className={estilo.buscador}>
          <div className={estilo.lupa}>
            <input
              placeholder="Buscar"
              onClick={() => activarBuscador(true)}
              onChange={capturarInput}
              value={input}
            />

            <div
              className={estilo.icono_lupa}
              onClick={() => activarLupaResponsive(true)}
            >
              <svg width="28" height="28" viewBox="0 0 24 24">
                <path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"></path>
              </svg>
            </div>

            {resultado.length > 0 ? (
              <div
                className={
                  activarBuscar
                    ? estilo.buscador_resultados
                    : estilo.no_buscador
                }
              >
                {resultado.map((e, i) => (
                  <Link
                    key={i}
                    to={"/" + e.nombre}
                    onClick={() => activarBuscador(false)}
                  >
                    <div className={estilo.buscador_dato}>
                      <svg width="22" height="22" viewBox="0 0 24 24">
                        <path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"></path>
                      </svg>
                      <p>{e.nombre}</p>
                    </div>
                  </Link>
                ))}
              </div>
            ) : null}
          </div>

          <div className={estilo.microfono}>
            <svg width="26" height="26" viewBox="0 0 24 24">
              <path d="M16 12V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 0 0-.209.025A4.006 4.006 0 0 0 8 6v6c0 2.206 1.794 4 4 4s4-1.794 4-4zm-6 0V6c0-1.103.897-2 2-2a.89.89 0 0 0 .163-.015C13.188 4.06 14 4.935 14 6v6c0 1.103-.897 2-2 2s-2-.897-2-2z"></path>
              <path d="M6 12H4c0 4.072 3.061 7.436 7 7.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6z"></path>
            </svg>
          </div>
        </div>

        <div className={estilo.subir} onClick={subir}>
          <svg width="28" height="28" viewBox="0 0 24 24">
            <path d="M18 7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3.333L22 17V7l-4 3.333V7zm-4 6h-3v3H9v-3H6v-2h3V8h2v3h3v2z"></path>
          </svg>

          <p>Subir</p>
        </div>

        {activarSubir ? <SubirVideo></SubirVideo> : null}
      </div>
    </div>
  );
}

export default Menu;
